import angular = require("angular");
import TPL = require("templates");

export class ModalActionBarDirective {

  template = TPL.contentDirectives.modalActionBar;
  scope = {
    params: "=params"
  }
  link;

  static factory() {
    return () => new ModalActionBarDirective();
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/modalActionBar.ts
 **/